package ai.flowstorm.studio.ui.data

import ai.flowstorm.common.id.isNew
import ai.flowstorm.studio.model.Initiation
import ai.flowstorm.studio.model.Space
import ai.flowstorm.studio.resources.space.ApplicationResource
import ai.flowstorm.studio.resources.space.InitiationResource
import ai.flowstorm.studio.resources.space.UserAssignmentResource
import ai.flowstorm.common.model.idPair
import kotlinx.coroutines.launch
import ai.flowstorm.common.ui.EntityForm
import ai.flowstorm.common.ui.UiHelpers
import ai.flowstorm.common.ui.form.ListIdSelect
import ai.flowstorm.common.ui.form.SelectId
import ai.flowstorm.studio.common.state.AppState
import io.kvision.form.text.Text
import io.kvision.i18n.tr

class PlaylistTestForm : EntityForm<Initiation>(InitiationResource) {

    var initiationId: String? = null

    override suspend fun createOrUpdate(entity: Initiation) {
        val initiation = if (entity.id.isNew()) {
            model.create(entity)
        } else {
            model.update(entity)
        }
        initiationId = initiation.id.value
    }

    init {
        load(Initiation(space_id = AppState.state.spaceId))
        add(
            Initiation::name,
            Text(label = tr("Name")),
            required = true,
            requiredMessage = tr("Required field")
        )
        add(
            Initiation::deviceType,
            Text(label = tr("Device Type"), value = "Playlist"),
            required = true,
            requiredMessage = tr("Required field")
        ).apply {
            form.fields["deviceType"]?.disabled = true
        }
        add(
            Initiation::application_id,
            SelectId(label = tr("Application")).apply {
                mainScope.launch {
                    options = UiHelpers.options(ApplicationResource)
                }
            },
            required = true,
            requiredMessage = tr("Required field")
        )
        add(
            Initiation::users_id,
            ListIdSelect(label = tr("Users")).apply {
                mainScope.launch {
                    options = UiHelpers.options(UserAssignmentResource) { e:Space.UserAssignment -> e._user?.idPair() }
                }
            },
            required = true,
            requiredMessage = tr("Required field")
        )
        add(
            Initiation::coreUrl,
            Text(label = tr("Custom Core URL"))
        )
        add(
            Initiation::playlistId,
            Text(label = tr("Playlist ID"))
        )
        add(
            Initiation::hours,
            Text(label = tr("Hours"))
        )
    }
}